<template>
    <div class="profile-card-button">
        <el-button
            v-if="CandidateBoardStore.isAddedToBoard(profile.id)"
            type="info"
            @click.stop="CandidateBoardStore.removeFromBoard(profile.id)"
        >
            <span class="standard">
                {{
                    $trans(
                        "web_search.profile_card.remove_from_candidate_board"
                    )
                }}
                <el-icon class="el-icon--right"><CircleCloseIcon /></el-icon>
            </span>
        </el-button>
        <el-button
            v-else
            type="primary"
            @click.stop="showConfirmationModal"
        >
            <span class="standard">
                {{ $trans("web_search.profile_card.add_to_candidate_board") }}
                <el-icon class="el-icon--right"
                    ><img
                        src="/media/images/web_search/clipboard-plus.svg"
                        alt="Trash Icon"
                        class="add-to-board-icon"
                /></el-icon>
            </span>
            <span class="hover">
                <el-icon class="el-icon--right"
                    ><img
                        src="/media/images/web_search/clipboard-plus.svg"
                        alt="Trash Icon"
                        class="add-to-board-icon"
                /></el-icon>
            </span>
        </el-button>
    </div>
</template>

<script>
import { Check as CheckIcon } from "@element-plus/icons-vue";
import { Plus as PlusIcon } from "@element-plus/icons-vue";
import { CircleClose as CircleCloseIcon } from "@element-plus/icons-vue";
import { CirclePlus as CirclePlusIcon } from "@element-plus/icons-vue";

import { mapStores } from "pinia";
import { useCandidateBoardStore } from "@/stores/CandidateBoardStore";

export default {
    components: {
        CheckIcon,
        PlusIcon,
        CircleCloseIcon,
        CirclePlusIcon,
    },
    props: {
        profile: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapStores(useCandidateBoardStore),
    },
    methods: {
        showConfirmationModal() {
            this.CandidateBoardStore.addToBoard(this.profile);
            this.$emit("showConfirmationModal", this.profile);
        },
    },
};
</script>

<style scoped>
.el-button--primary {
    --el-button-text-color: var(--el-color-white);
    --el-button-bg-color: #41abc4;
    --el-button-border-color: #41abc4;
    --el-button-outline-color: var(--el-color-primary-light-5);
    --el-button-active-color: var(--el-color-primary-dark-2);
    --el-button-hover-text-color: var(--el-color-white);
    --el-button-hover-link-text-color: var(--el-color-primary-light-5);
    --el-button-hover-bg-color: #2699b2;
    --el-button-hover-border-color: #2699b2;
    --el-button-active-bg-color: var(--el-color-primary-dark-2);
    --el-button-active-border-color: var(--el-color-primary-dark-2);
    --el-button-disabled-text-color: var(--el-color-white);
    --el-button-disabled-bg-color: var(--el-color-primary-light-5);
    --el-button-disabled-border-color: var(--el-color-primary-light-5);
}

.profile-card-button .el-button {
    width: 100%;
    position: relative;
    justify-content: left;
    cursor: pointer;
    height: 38px;
    border-radius: 5px;
}

.el-button--info:hover {
    background-color: #f56c6c;
    border-color: #f56c6c;
    cursor: pointer;
}

.el-button .standard {
    display: block;
}

.el-button .hover {
    display: none;
}
.el-button:hover .hover {
    display: block;
}

.el-icon--right {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 24px;
    width: 24px;
}

.el-icon svg {
    height: 100%;
    width: 100%;
}

.add-to-board-icon {
    filter: brightness(0%) hue-rotate(360deg) saturate(1000%) contrast(1000%)
        invert(100%);
    scale: 1.3;
    margin-top: -3px;
}

@media only screen and (max-width: 790px) {
    .el-button--info {
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    .el-button--info .standard {
        display: block;
    }
    .el-button--info .hover {
        display: block;
    }
}
</style>
